/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AptosAnalyticsChartDataInfo } from './AptosAnalyticsChartDataInfo';

export type AptosAnalyticsChartDataResultInfo = {
    DATANM: string;
    CHRTTP: AptosAnalyticsChartDataResultInfo.CHRTTP;
    DATA: Array<AptosAnalyticsChartDataInfo>;
};

export namespace AptosAnalyticsChartDataResultInfo {

    export enum CHRTTP {
        LINE = 'LINE',
        BAR = 'BAR',
        STACKED_BAR = 'STACKED_BAR',
        HORIZON_BAR = 'HORIZON_BAR',
        AREA = 'AREA',
        AREA_RANGE = 'AREA_RANGE',
        CURVE = 'CURVE',
        PIE = 'PIE',
        SANKEY = 'SANKEY',
        SCATTER = 'SCATTER',
    }


}

